import React from 'react'
import MakeHomepage from '../make-homepage'

const MakeHomepageEn = () => {
    return <MakeHomepage languageCode="en" />
}

export default MakeHomepageEn
